import { accountKeys } from "@apis/accounts/queryKeys"
import { prospectsKeys } from "@apis/prospects/queryKeys"
import type { IProspectPhone } from "@apis/prospects/types"
import { useDeleteProspectPhoneNumberMutation } from "@apis/prospects/useProspects"
import { Button } from "@components/ui/button"
import { useQueryClient } from "@tanstack/react-query"
import { Loader2 } from "lucide-react"
import { toast } from "sonner"

type TDeleteProspectPhoneNumberButtonProps = {
  prospectPhoneNumber: IProspectPhone
  accountId: string
}
export const DeleteProspectPhoneNumberButton = ({
  prospectPhoneNumber,
  accountId,
}: TDeleteProspectPhoneNumberButtonProps) => {
  const queryClient = useQueryClient()
  const deleteProspectPhoneNumber = useDeleteProspectPhoneNumberMutation()
  const handleClick = () => {
    deleteProspectPhoneNumber.mutate(
      {
        prospect_guid: prospectPhoneNumber.prospect_guid,
        request: {
          prospect_phone_id: prospectPhoneNumber.prospect_phone_id,
        },
      },
      {
        onSuccess: () => {
          toast.success("Successfully deleted prospect phone number!")
          queryClient.invalidateQueries({
            queryKey: prospectsKeys.prospectPhoneNumbers(
              prospectPhoneNumber.prospect_guid,
            ),
          })
          queryClient.invalidateQueries({
            queryKey: accountKeys.detail(accountId),
          })
        },
        onError: (error) =>
          toast.error(`Error deleting prospect phone number! ${error}`),
      },
    )
  }

  return (
    <Button
      onClick={handleClick}
      size="sm"
      variant="destructive"
      disabled={deleteProspectPhoneNumber.isPending}
    >
      {deleteProspectPhoneNumber.isPending ? (
        <Loader2 className="tw:animate-spin" />
      ) : (
        <span>Delete</span>
      )}
    </Button>
  )
}
